<template>
    <div :class="getCSSClass('model-manager-delete-confirmation-form')">
        <div :class="getCSSClass('model-manager-delete-confirmation-form-label')">
            <span v-html="label"></span>
        </div>
        <div v-if="useCheckCode" :class="getCSSClass('model-manager-delete-confirmation-form-checkcode-row')">
            <label v-html="translate('Törlés ellenőrzőkódja')"></label>
            <label v-html="checkCode" :class="getCSSClass('model-manager-delete-confirmation-form-checkcode-label')"></label>
        </div>
        <div v-if="useCheckCode" :class="getCSSClass('model-manager-delete-confirmation-form-checkcode-row')">
            <label v-html="translate('Írja be az ellenőrzőkódot')"></label>
            <input v-model="verificationCode"
                   type="text"
                   :class="getCSSClass('model-manager-delete-confirmation-form-checkcode-input')">
        </div>
        <div :class="getCSSClass('model-manager-delete-confirmation-form-buttons-container')">
            <button type="button"
                    v-if="buttons['confirmDeletion']"
                    :class="getCSSClass('model-manager-confirmDeletion-button')"
                    v-html="buttons['confirmDeletion']['html']"
                    @click="confirmDeletion"
                    :disabled="buttonDisabled"
            ></button>
            <button type="button"
                    v-if="buttons['cancelDeletion']"
                    :class="getCSSClass('model-manager-cancelDeletion-button')"
                    v-html="buttons['cancelDeletion']['html']"
                    @click="cancelDeletion"
            ></button>

        </div>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate'],
        props: {
            label: {type: String},
            buttons: {type: Object},
            subjectLabel: {type: String},
            useCheckCode: {type: Boolean, default: true}
        },
        data: function () {
            return {
                loading: false,
                checkCode: '',
                verificationCode: '',
            }
        },
        mounted() {
            this.checkCode = this.generateRandomCode();
        },
        methods: {
            generateRandomCode: function(length = 5) {
                let choices = 'ACDEFGHJKLMNPQRSTUVY345679'.split('');
                let result = [];
                for (let t = 0; t < length; t++) {
                    result.push(choices[Math.floor(choices.length * Math.random())]);
                }
                return result.join('');
            },
            confirmDeletion: function() {
                this.loading = true;
                this.$emit('confirmed');
            },
            cancelDeletion: function() {
                this.loading = true;
                this.$emit('canceled');
            }
        },
        computed: {
            buttonDisabled: function() {
                if (!this.useCheckCode) {
                    return this.loading
                }
                return this.loading || this.checkCode != this.verificationCode;
            }
        },
        watch: {}

    }
</script>
